import { useQuery } from '@ubisend/pulse-hooks';

const useVariables = () => {
  const { data = [] } = useQuery({
    queryKey: [
      'resolvers'
    ]
  });

  return {
    variables: data.reduce((all, current) => all.concat(current.variables), []),
    groupedVariables: data
  };
};

export default useVariables;
